module.exports = __webpack_public_path__ + "static/media/rasapi32_104.fe487258.ico";